const CustomizedMixins = {
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG',
      [{ name: 'CustomizedList', title: '我的专题' },
        { name: 'CustomizedThemeTemplate', title: '专题模板' }
      ])
    this.getH5Domain()
  },
  methods: {
    getH5Domain() {
      const h5DomainUrl = this.$store.getters.h5DomainUrl
      if (!h5DomainUrl) {
        const params = {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }
        this.getHttpServices().getUserService().post('homepage/H5/getDomain', params).then(res => {
          const h5Url = res ? res : this.getPlatformConfig().h5Url
          this.$store.commit('SET_H5_DOMAIN', h5Url)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }
}
export default CustomizedMixins